import { getPortalAppVersion } from './util-common';

export const getHeaders = session => ({
  headers: {
    'X-DreamFactory-Api-Key': session.apiKey,
    'X-Client-Name': `Webportal`,
    'X-APP-VERSION': getPortalAppVersion(),
    ...(session.seocode && session.seocode != ''
      ? { 'X-APP-ID': `${!session.isapi4 ? 'DEV-' : ''}WEB-${session.seocode}` }
      : {}),
    ...(session.sessionToken && session.sessionToken != ''
      ? { 'X-DreamFactory-Session-Token': session.sessionToken }
      : {}),
    ...(session.eventid ? { eventid: `${session.eventid}` } : {}),
    'Content-Type': 'application/json; charset=utf-8'
  }
});

export const getMultiPartHeaders = session => ({
  headers: {
    'X-DreamFactory-Api-Key': session.apiKey,
    'X-Client-Name': `Webportal`,
    'X-APP-VERSION': getPortalAppVersion(),
    ...(session.seocode && session.seocode != ''
      ? { 'X-APP-ID': `${!session.isapi4 ? 'DEV-' : ''}${session.seocode}` }
      : {}),
    ...(session.sessionToken && session.sessionToken != ''
      ? { 'X-DreamFactory-Session-Token': session.sessionToken }
      : {}),
    ...(session.eventid ? { eventid: `${session.eventid}` } : {}),
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

export const getHeadersWithParams = (session, params) => ({
  headers: {
    'X-DreamFactory-Api-Key': session.apiKey,
    'X-Client-Name': `Webportal`,
    'X-APP-VERSION': getPortalAppVersion(),
    ...(session.seocode && session.seocode != ''
      ? { 'X-APP-ID': `${!session.isapi4 ? 'DEV-' : ''}${session.seocode}` }
      : {}),
    ...(session.sessionToken && session.sessionToken != ''
      ? { 'X-DreamFactory-Session-Token': session.sessionToken }
      : {}),
    ...(session.eventid ? { eventid: `${session.eventid}` } : {}),
    'Content-Type': 'multipart/form-data'
  },
  params: params
});

export const getHeadersMultiPart = session => ({
  headers: {
    'X-DreamFactory-Api-Key': session.apiKey,
    'X-Client-Name': `Webportal`,
    'X-APP-VERSION': getPortalAppVersion(),
    ...(session.seocode && session.seocode != ''
      ? { 'X-APP-ID': `${!session.isapi4 ? 'DEV-' : ''}${session.seocode}` }
      : {}),
    ...(session.sessionToken && session.sessionToken != ''
      ? { 'X-DreamFactory-Session-Token': session.sessionToken }
      : {}),
    ...(session.eventid ? { eventid: `${session.eventid}` } : {}),
    'Content-Type':
      'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s'
  }
});

export const getImageHeaders = session => ({
  headers: {
    'X-DreamFactory-Api-Key': session.apiKey,
    'X-Client-Name': `Webportal`,
    'X-APP-VERSION': getPortalAppVersion(),
    ...(session.seocode && session.seocode != ''
      ? {
          'X-APP-ID': `${!session.isapi4 ? 'DEV-' : ''}${session.seocode}`
        }
      : {}),
    ...(session.sessionToken && session.sessionToken != ''
      ? { 'X-DreamFactory-Session-Token': session.sessionToken }
      : {}),
    ...(session.eventid ? { eventid: `${session.eventid}` } : {}),
    contentType: 'application/json; charset=utf-8'
  }
});

export const getExtraImageHeaders = (session, filename) => ({
  headers: {
    'X-DreamFactory-Api-Key': session.apiKey,
    'X-Client-Name': `Webportal`,
    'X-APP-VERSION': getPortalAppVersion(),
    ...(session.seocode && session.seocode != ''
      ? {
          'X-APP-ID': `${!session.isapi4 ? 'DEV-' : ''}${session.seocode}`
        }
      : {}),
    ...(session.sessionToken && session.sessionToken != ''
      ? { 'X-DreamFactory-Session-Token': session.sessionToken }
      : {}),
    ...(session.eventid ? { eventid: `${session.eventid}` } : {}),
    contentType: 'application/json; charset=utf-8',
    'X-File-Name': filename
  }
});
